import React from 'react';

export const RosettaLogo = () => <img width={40} src='/Rosetta-Logo.png' />;
